export enum PositionCloseReasonType {

    UserRequest = 1,
}
